// src/App.js
import React, { Fragment, useEffect } from "react";
import Header from "./components/Header";
// import Container from "./components/Container";
import Smallercont from "./components/Smallercont";
import Work from "./components/Work";
import Career from "./components/Career";
// import Blogs from "./components/Blogs";
import About from "./components/About";
import Blog from "./components/Blog";
import {
  HashRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import "./assets/styles/main.css";

function App() {
  // Always use light theme
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "light");
  }, []);

  const sharedLayout = (
    <>
      <Smallercont>
        <Header />
        <Outlet />
      </Smallercont>
    </>
  );

  return (
    <Router>
      <div className="App">
        <div className="container">
          <Routes>
            <Route path="/" element={sharedLayout}>
              <Route
                index
                element={
                  <Fragment>
                    <About />
                    {/* <Blogs /> */}
                  </Fragment>
                }
              />
            </Route>
            <Route path="/blog/:link" element={<Blog />} />
            <Route path="/work" element={<Work />} />
            <Route path="/career" element={<Career />} />
          </Routes>
        </div>
        <div className="footer">&copy; 2026 Abhishek Kadian</div>
      </div>
    </Router>
  );
}

export default App;
